<div id="breadcrumb-container" class="breadcrumb-container text" (click)="goBack()">
  <div class="breadcrumb-left">
    <image-loader-utils url="up-arrow" extraClasses="arrow-icon left"></image-loader-utils>
  </div>
  <div class="breadcrumb-mid" *ngIf="this._DataHelper.selectedMatch">
    <div class="breadcrumb-tournament-name">
      <ng-container *ngIf="this._DataHelper.selectedMatch?.TournamentName === ('MyBets' | t); else flag">
        <div class="breadcrumb-turnament-icon">
          <image-loader-utils url="my-bets" extraClasses="svg"></image-loader-utils>
        </div>
      </ng-container>

      <ng-template #flag>
        <div class="breadcrumb-turnament-icon">
          <image-loader-utils [url]="this._DataHelper.selectedMatch?.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
        </div>
      </ng-template>

      <strong class="template-name">
        {{ this._DataHelper.selectedMatch?.TournamentName }}
      </strong>
    </div>
  </div>

  <div class="breadcrumb-mid" *ngIf="!this._DataHelper.selectedMatch">
    <div class="breadcrumb-turnament-icon">
      <image-loader-utils url="sports" extraClasses="svg"></image-loader-utils>
    </div>
    <div class="breadcrumb-tournament-noname">
      <strong> {{ 'SPORTS' | t }} </strong>
    </div>
  </div>

  <div class="breadcrumb-right">
    <div class="star-icon"></div>
  </div>
</div>

<div class="b3000-scoreboard-container text" *ngIf="showScoreBoard">
  <div class="box first" (click)="addMatch2Favs()">
    <image-loader-utils url="star" [extraClasses]="'star-icon ' + (isFavorite ? 'matchfavourited' : '')"></image-loader-utils>
  </div>
  <div class="box second">
    {{ this.event?.HomeTeam }}
  </div>
  <div class="box third">
    <div class="date">
      {{ this.event?.EventFullDate | dateFormat : 'dd-MM' }}
    </div>
    <div class="time">
      {{ this.event?.EventFullDate | dateFormat : 'HH:mm' }}
    </div>
  </div>
  <div class="box fourth">
    {{ this.event?.AwayTeam }}
  </div>
  <div class="box fifth" (click)="openHeadToHeadDialog()">
    <image-loader-utils url="signal" extraClasses="signal-icon"></image-loader-utils>
  </div>
</div>
<div class="widgets">
  <div>
    <div class="sr-widget sr-widget-2"></div>
  </div>
</div>

<ng-container [ngSwitch]="['cangobet'] | getProductName">
  <ng-container *ngSwitchCase="'cangobet'">
    <div *ngIf="isTracerMapped; else notMapped" id="lsSportWrapperElemCango"></div>
  </ng-container>

  <ng-template #notMapped>
    <div class="mappingNotAllowed">
      <div class="icon-svg" [inlineSVG]="'icons/noLive.svg' | getAssetsPath"></div>
    </div>
    <div class="mappingNotAllowed">
      {{ 'LSTracker_Missing' | t }}
    </div>
  </ng-template>

  <ng-container *ngSwitchDefault>
    <!--div class="widgets">
      <div><div class="sr-widget sr-widget-1"></div></div>
      <iframe *ngIf="this.enableBetGeniusTracker" scrolling="no" id="betgenius-iframe" [src]="this.betgeniustrackerlink" width="100%" height="289"></iframe>
    </div-->
  </ng-container>
</ng-container>

<div class="event-detail-tab">
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 2 }" (click)="eventDetailTabItemChange(2)">
    {{ 'OddsAll' | t }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 1 }" (click)="eventDetailTabItemChange(1)">
    {{ 'OddsPopular' | t }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 3 }" (click)="eventDetailTabItemChange(3)">
    {{ 'OddsMatchResult' | t }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 7 }" (click)="eventDetailTabItemChange(7)">
    {{ 'OddsOverUnder' | t }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 4 }" (click)="eventDetailTabItemChange(4)">
    {{ 'OddsFirstHalf' | t }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 6 }" (click)="eventDetailTabItemChange(6)">
    {{ 'OddsAsia' | t }}
  </div>
</div>
<div class="event-detail-tab-content" id="event-detail-tab-content">
  <ng-container *ngFor="let oddType of this.eventdetailList | groupOddsByName | sortBy : false : 'seq'; let i = index">
    <div class="event-detail-odd-box">
      <div class="event-detail-odd-title">
        {{ oddType.GroupName.split('|')[1] }}
      </div>
      <div class="event-detail-odd-content">
        <ng-container *ngFor="let odd of oddType.eOdds | sortBy : true : 'SeqNumber'">
          <div
            class="event-detail-odd-button"
            (click)="clickOdd(odd)"
            [ngClass]="{
              active: checkOddId(odd.OddId) === 'active',
              'btn-single': oddType.eOdds.length == 1,
              'btn-double': oddType.eOdds.length == 2,
              'btn-triple': oddType.eOdds.length == 3,
              'btn-multiple': oddType.eOdds.length > 3
            }">
            <div class="event-detail-odd-outcome">{{ odd.OutComeOrginal }}</div>
            <div class="event-detail-odd-value">
              {{ odd.OddValue | number : '1.2-2' }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <div *ngIf="this.eventdetailList == undefined || this.eventdetailList.length < 1" class="event-detail-skeleton">
    <ngx-skeleton-loader [theme]="{ height: '30px', width: '90%', background: 'var(--white-color-300)' }" count="10"></ngx-skeleton-loader>
  </div>
  <div class="top-button-container" (click)="ScrollToTop()">
    <div class="top-button">
      <div class="text-name">
        {{ 'back_to_top' | t }}
      </div>
      <div class="right">
        <image-loader-utils url="up-arrow" extraClasses="arrow-icon up"></image-loader-utils>
      </div>
    </div>
  </div>
</div>
